import $api from "@/zapi-frontend/shared/api/axios";

const MIME: Record<"pdf" | "docx" | "md", string> = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  md: "text/markdown"
};

export async function exportProject(
  projectName: string,
  projectId: number,
  docType: "docx" | "pdf" | "md",
  options?: {
    includeAnalysisQuestions?: boolean;
    includeIntelligenceQuestions?: boolean;
  }
): Promise<void> {
  const fileName = "report-summary";

  try {
    const params = new URLSearchParams({
      docType,
      ...(options?.includeAnalysisQuestions !== undefined && {
        includeAnalysisQuestions: String(options.includeAnalysisQuestions)
      }),
      ...(options?.includeIntelligenceQuestions !== undefined && {
        includeIntelligenceQuestions: String(options.includeIntelligenceQuestions)
      })
    });

    const response = await $api.get(`/projects/${projectId}/export?${params.toString()}`, {
      responseType: "blob"
    });
    if (response.status !== 200) {
      throw new Error("Failed to export");
    }
    const pdfBlob = new Blob([response.data], { type: MIME[docType] });

    const downloadUrl = window.URL.createObjectURL(pdfBlob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `${fileName}.${docType}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Error exporting", error);
    throw error;
  }
}
